import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import getAccessRights from "components/Common/getAccessRights";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { changeAllowanceStatus, fetchAllowances, createAllowanceRequest, deleteAllowance } from "store/actions";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";

const PayrollAllowances = () => {
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    allowances,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    allowances: state.PayrollSetupAllowanceReducer?.allowances ?? [],

    loading: state.PayrollSetupAllowanceReducer?.loading,
    error: state.PayrollSetupAllowanceReducer?.error,
    success: state.PayrollSetupAllowanceReducer?.success,
  }));

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchAllowances(unitId));
  }, [dispatch]);

  useEffect(() => {
    if (success) {
      dispatch(fetchAllowances(authDetails?.unit_id));
      formik.resetForm();
      setIsEdit(false);
      setEditId(null);
    }
  }, [authDetails, success, dispatch]);

  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);
  const [isDelete, setIsDelete] = useState(false);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const accessRight = getAccessRights(location.pathname, history);
  }, [location]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      allowance: "",
      description: "",
      isFixed: false,
      visibility: false,
      is_pf: false,
      is_esi: false,
      is_extrahours: false,
      unitid: authDetails?.unit_id,
      createdby: authDetails?.user_id,
    },
    validationSchema: Yup.object({
      allowance: Yup.string().required("Allowance is required").matches(/^\S.*\S$|^\S$/, "Leading and trailing spaces are not allowed"),
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("pay_allow_id", editId ? editId : 0);
      formData.append("allow_name", values.allowance);
      formData.append("allow_desc", values.description);
      formData.append("is_fixed", values.isFixed ? 1 : 0);
      formData.append("is_visible", values.visibility ? 1 : 0);

      formData.append("is_pf", values.is_pf ? 1 : 0);
      formData.append("is_esi", values.is_esi ? 1 : 0);
      formData.append("is_extrahours", values.is_extrahours ? 1 : 0);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      dispatch(createAllowanceRequest(formData))
    },
  });


  const handleEdit = (row) => {
    formik.setValues({
      allowance: row.allow_name,
      description: row.allow_desc,
      isFixed: row.is_fixed === 1,
      visibility: row.is_visible === 1,
      is_pf: row.is_pf === 1,
      is_esi: row.is_esi === 1,
      is_extrahours: row.is_extrahours === 1,
      unitid: authDetails?.unit_id,
      createdby: authDetails?.user_id,
    });
    setIsEdit(true);
    setEditId(row.pay_allow_id);
  };



  const handleDelete = (allowancelist) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to delete this.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("pay_allow_id", allowancelist.pay_allow_id);
        formData.append("create_by", authDetails?.user_id);
        formData.append("unit_id", authDetails?.unit_id);
        dispatch(deleteAllowance(formData));
      }
    });
    //setId(modulelists._id)
    //setModules(modulelists);
    //setIsDelete(true);
  };

  const handleCancel = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
  };

  const columns = [
    {
      Header: "S#",
      Cell: ({ row }) => allowances.length - row.index, // Assuming `data` holds the table values
      className: "serial-no text-center",
    },
    {
      Header: "ALLOWANCE",
      accessor: "allow_name",
    },
    {
      Header: "DESCRIPTION",
      accessor: "allow_desc",
    },
    {
      Header: "IS_ESI",
      accessor: row => (row.is_esi === 1 ? "Yes" : "No"),
    },
    {
      Header: "IS_EXTRAHOURS",
      accessor: row => (row.is_extrahours === 1 ? "Yes" : "No"),
    },
    {
      Header: "IS_FIXED",
      accessor: row => (row.is_fixed === 1 ? "Yes" : "No"),
    },
    {
      Header: "IS_PF",
      accessor: row => (row.is_pf === 1 ? "Yes" : "No"),
    },
    {
      Header: "VISIBILITY",
      accessor: row => (row.is_visible === 1 ? "Yes" : "No"),
    },
    {
      Header: "CREATED_BY",
      accessor: "create_by",
    },
    {
      Header: "CREATED_DT",
      accessor: "create_dt",
    },

    {
      Header: "ACTIONS",
      Cell: (cellProps) => {
        //const { status, id} = cellProps.row.original;
        //const isActive = status === 1; // Status 1 = Active
        const { b_active, pay_allow_id } = cellProps.row.original;
        const isActive = b_active === 1;
        return (
          <div className="text-center">

            <Link
              to="#"
              style={{ color: isActive ? "green" : "red" }}
              onClick={() => handleToggleStatus(pay_allow_id, isActive)} className="me-2"
            >
              <i
                className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
                id={`status-tooltip-${cellProps.row.id}`}
              />
              <UncontrolledTooltip placement="top" target={`status-tooltip-${cellProps.row.id}`}>
                {isActive ? "Mark Inactive" : "Mark Active"}
              </UncontrolledTooltip>
            </Link>


            <Link
              to="#"
              className="text-success"
              onClick={() => handleEdit(cellProps.row.original)}
            >
              <i className="bx bxs-edit font-size-18" id="edittooltip" />
              <UncontrolledTooltip placement="top" target="edittooltip">
                Edit
              </UncontrolledTooltip>
            </Link>

            {
              /*
              <Link
                to="#"
                className="text-danger"
                onClick={() => handleDelete(cellProps.row.original) }
              >
                <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                <UncontrolledTooltip placement="top" target="deletetooltip">
                  Delete
                </UncontrolledTooltip>
              </Link>
              */
            }

          </div>
        );
      },
    },
  ];

  const handleToggleStatus = (id, isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this allowance.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
        const formData = new FormData();
        formData.append("pay_allow_id", id);
        formData.append("create_by", authDetails?.user_id);
        formData.append("unit_id", authDetails?.unit_id);
        dispatch(deleteAllowance(formData));
      }
    });
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading} />
        <DeleteModal
          show={isDelete}
          // onDeleteClick={handleDeleteModule}
          onCloseClick={() => setIsDelete(false)}
        />
        <Container fluid>
          {/* Breadcrumbs */}
          <Breadcrumbs title="Payroll / Setup" breadcrumbItem="Allowances" />

          {/* Input Section */}
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  {/* Allowance Field */}
                  <Col md="3">
                    <FormGroup>
                      <Label for="allowance">
                        Allowance <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="allowance"
                        name="allowance"
                        maxLength={50}
                        type="text"
                        value={formik.values.allowance}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.allowance && Boolean(formik.errors.allowance)}
                      />
                      {formik.touched.allowance && formik.errors.allowance && (
                        <div className="text-danger">{formik.errors.allowance}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Description Field */}
                  <Col md="3">
                    <FormGroup>
                      <Label for="description">
                        Description <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="description"
                        name="description"
                        type="text"
                        maxLength={100}
                        value={formik.values.description}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.description && Boolean(formik.errors.description)}
                      />
                      {formik.touched.description && formik.errors.description && (
                        <div className="text-danger">{formik.errors.description}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md="1">
                    <FormGroup check className="d-flex align-items-center">
                      <Label check>
                        <Input
                          type="checkbox"
                          id="is_esi"
                          name="is_esi"
                          checked={formik.values.is_esi}
                          onChange={formik.handleChange}
                        />
                        Is ESI
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="2">
                    <FormGroup check className="d-flex align-items-center">
                      <Label check>
                        <Input
                          type="checkbox"
                          id="is_extrahours"
                          name="is_extrahours"
                          checked={formik.values.is_extrahours}
                          onChange={formik.handleChange}
                        />
                        Is Extra Hours
                      </Label>
                    </FormGroup>
                  </Col>
                  {/* Is Fixed Checkbox */}
                  <Col md="1">
                    <FormGroup check className="d-flex align-items-center">
                      <Label check>
                        <Input
                          type="checkbox"
                          id="isFixed"
                          name="isFixed"
                          checked={formik.values.isFixed}
                          onChange={formik.handleChange}
                        />
                        Is Fixed
                      </Label>
                    </FormGroup>
                  </Col>

                  <Col md="1">
                    <FormGroup check className="d-flex align-items-center">
                      <Label check>
                        <Input
                          type="checkbox"
                          id="is_pf"
                          name="is_pf"
                          checked={formik.values.is_pf}
                          onChange={formik.handleChange}
                        />
                        Is PF
                      </Label>
                    </FormGroup>
                  </Col>

                  {/* Visibility Checkbox */}
                  <Col md="1">
                    <FormGroup check className="d-flex align-items-center">
                      <Label check>
                        <Input
                          type="checkbox"
                          id="visibility"
                          name="visibility"
                          checked={formik.values.visibility}
                          onChange={formik.handleChange}
                        />
                        Visibility
                      </Label>
                    </FormGroup>
                  </Col>

                  {/* Buttons */}
                  <Col className="d-flex mob-center align-items-center justify-content-end">
                    <Button type="submit" className="btn btn-primary me-2 mt-2">
                      <i className="fas fa-save me-1" /> {isEdit ? "UPDATE" : "SAVE"}
                    </Button>
                    {/* <Button type="reset" className="btn button-cancel me-2" onClick={handleCancel}>
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button> */}
                    <Button
                      type="button"
                      color="secondary"
                      className="btn button-cancel me-2 mt-2"
                      onClick={() => {
                        Swal.fire({
                          title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                          showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                        }).then((result) => {
                          if (result.isConfirmed) {
                            handleCancel();
                          }
                        });
                      }}
                    >
                      <i className="fas fa-sync me-1" /> CANCEL
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={allowances && allowances?.length > 0 ? allowances : []}
                isGlobalFilter={true}
                customPageSize={10}
              // className="custom-header-css"
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PayrollAllowances;
